import React from 'react'
import styled from '@emotion/styled'
import { keyframes } from "@emotion/core";
import ScaleLoader from "react-spinners/ScaleLoader";
import { css } from "@emotion/core";
const Load = keyframes`
 from, 0%, to {
    background-color:var(--color-white);
    width:2.5rem;
  }
80%{
    background-color:var(--color-red-200);
    width:2.5rem;
}
  100%{
    background-color:var(--color-blue-200);
    width:4rem;
  }

`;
const Spin = keyframes`
 from, 0%, to {
    transform:rotateY(-90deg);
  }
80%{
    transform:rotateY(-180deg);
}
  100%{
    transform:rotateY(-90deg);
  }

`;
const Grow = keyframes`
 from, 0%, to {
    transform:scale(0.2);
  }
20%{
    transform:scale(0.6);
}
  40%{
    transform:scale(0.8);
  }
  60%{
    transform:scale(0.6);
  }
  80%{
    transform:scale(0.2);
  }
  100%{
    transform:scale(0.2);
  }

`;

const LoadingWrapper = styled.div`
  z-index:999;
  position:absolute;
  justify-self:center;
  justify-content:center;
  width:12.5rem;
  height:12.5rem;
  border-radius:7.75rem;
  background-color:var(--color-white);
  border: var(--space-10) solid var(--color-blue-400);
  top:12.5rem;
  animation: ${Spin} 1.1s linear infinite;
  img{
      width:100%;
      height:100%;
      object-fit:contain;
      animation: ${Grow} 1.1s linear infinite;
  }
`;

const LoadingContainer = styled.div`

  width:3rem;
  height:3rem;
  position:relative;
  justify-content:center;
  align-items:center;
  border-radius:var(--space-24);
  background-color:var(--color-white);
  //animation: ${Load} 0.6s linear infinite;
`;

const LoadingDot = styled.div`
  width:1rem;
  position:absolute;
  background-color:blue;
  border-radius:var(--space-24);
  
`;

const SpinnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height:calc((var(--footer-height) - var(--header-height)));
`;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  justify-self:center;
  z-index:1;
`;

const LoadingComponent = () => {
    return (
          <SpinnerContainer>
            <ScaleLoader
                css={override}
                margin={4}
                radius={2}
                height={40}
                width={2}
                color={"#02B2D9"}
                loading={true}
            />
          </SpinnerContainer>
    )
}

export default LoadingComponent
